import _ from 'lodash';
import {
   UPDATE_GAME,
   UPDATE_CLUES,
   FETCH_GAMES,
   FETCH_GAME,
   DELETE_GAME,
   CREATE_GAME
} from "../constants/ActionTypes";

// Returns all games, as a map with their ids as the key.
export default function (state = null, action) {

    switch (action.type) {
        case CREATE_GAME:
        case UPDATE_GAME:
           // if game is null, create it.
            if (!action.payload) {

                return state;
            }
            else {
                const newGameData = action.payload;

                const id = newGameData.id;
                if (!id) {
                    console.warn("no id!!!");
                    return state;
                }
                const existingGame = state[id];

                const mergedData = existingGame
                    ? { ...existingGame, ...newGameData }
                    : newGameData;

                return { ...state, [id]: mergedData };
            }

        case FETCH_GAMES:
            const fetchedGames = action.payload;

            // add gameMap in payload to existing gameMap, if any.
            if (!fetchedGames) {
                return state;
            } else {
                if (state) {
                    const newState = { ...state };
                    fetchedGames.forEach( (game) => {
                        newState[game.id] = game;
                    });
                    return newState
                } else {
                    return _.mapKeys(fetchedGames, 'id');
                }
            }

        case FETCH_GAME:
            const game = action.payload;
            if (!game) {
            } else {
                if ( state === null) {
                    state = [];
                }
                return { ...state, [game.id]: game };
            }
            return state;

        case DELETE_GAME:
            if (action.payload && state) {
                const gameId = action.payload;
                delete state[gameId];

                return { ...state };
            } else {
                return state;
            }

        case UPDATE_CLUES:
            if (state != null) {

                const id = action.payload.gameId;
                const clues = action.payload.clues;

                // copy of state (all gameMap), but with game specified by payload id copied with new state of clues
                return { ...state,   [id]: {...state[id], clues: clues } };
            }
            break;

        default:
            return state
    }

    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/reducer_games.js